import { render } from "./UsuariosContent.vue?vue&type=template&id=66218677"
import script from "./UsuariosContent.vue?vue&type=script&lang=js"
export * from "./UsuariosContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__